import { useEffect, useRef } from "react";
import { Alert, AlertTitle, Box, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import type { Tenant } from "./types.js";

interface Props {
  tenant: Tenant;
}

/**
 * UX brief §State 4. Auto-focused on mount. Single recovery action.
 */
export function WrongTenantAlert({ tenant }: Props) {
  const ref = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  useEffect(() => {
    ref.current?.focus();
  }, []);

  return (
    <Stack spacing={2} sx={{ width: "100%", maxWidth: 480 }}>
      <Alert
        ref={ref}
        tabIndex={-1}
        severity="warning"
        role="alert"
        variant="outlined"
      >
        <AlertTitle>Wrong tenant</AlertTitle>
        Your previous session was for a different tenant. Please sign in again
        to continue with <strong>{tenant.displayName}</strong>.
      </Alert>
      <Box>
        <Button
          variant="contained"
          fullWidth
          sx={{ minHeight: 44 }}
          onClick={() => navigate("/login", { replace: true })}
        >
          Continue
        </Button>
      </Box>
    </Stack>
  );
}
